export default "__VITE_ASSET__DXPcqZsM__"